const warnings = {
  exceedTaxRate: "Bør ikke være over trekkfri sats ({0})"
};

export default warnings;